'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import dynamic from 'next/dynamic'

import { useFeedback } from '../../hooks/useFeedback'
import type { NewsletterConfiguration } from '../../types/featureFlag'

const DoubleOptInSuccessFeedback = dynamic(
	async () =>
		(await import('./DoubleOptInSuccessFeedback/DoubleOptInSuccessFeedback'))
			.DoubleOptInSuccessFeedback
)

type FeedbackProps = {
	onFeedbackSent?(): void
	readonly sendSuccessFeedback: boolean
}
export function Feedback({
	onFeedbackSent = () => {},
	sendSuccessFeedback,
}: FeedbackProps) {
	const { enabled, variables } = useFeatureFlag<NewsletterConfiguration>(
		featureFlagKeys.NewsletterConfiguration
	)
	const doubleOptInEnabled = enabled && !!variables?.doubleOptIn
	const shouldSendFeedback =
		sendSuccessFeedback && enabled && !variables?.doubleOptIn
	useFeedback(shouldSendFeedback, onFeedbackSent)

	if (doubleOptInEnabled) {
		return (
			<DoubleOptInSuccessFeedback
				sendSuccessFeedback={sendSuccessFeedback}
				onFeedbackSent={onFeedbackSent}
			/>
		)
	}

	return null
}
